import type { LucideIcon } from 'lucide-react'
import {
  BaselineIcon,
  BoxIcon,
  Building2Icon,
  CalendarIcon,
  ChartNoAxesGantt,
  CircleChevronDownIcon,
  CircleQuestionMarkIcon,
  ClockIcon,
  HashIcon,
  Heading1Icon,
  Heading2Icon,
  Image,
  ListChecksIcon,
  ListIcon,
  MailIcon,
  MapPinIcon,
  MinusIcon,
  PackageIcon,
  PaperclipIcon,
  RulerIcon,
  SignatureIcon,
  SmartphoneIcon,
  TableIcon,
  TextAlignStartIcon,
  TypeIcon,
  UserIcon,
  UserStarIcon,
  Workflow,
} from 'lucide-react'

import { PermitFieldType } from '~/client/graph/types.generated'
import { LOCATION_GLYPHS } from '~/client/src/shared/components/SitemapHelpers/utils/locationGlyphs'
import MapViewLocationIcon from '~/client/src/shared/enums/SitemapAttributeIcon'
import {
  TextShortIcon,
  UserBellIcon,
  UserStarFilledIcon,
} from '~/client/src/shared/icons'

const EquipmentIcon = LOCATION_GLYPHS[MapViewLocationIcon.Equipment]

export const PERMIT_FIELD_GLYPHS: Record<PermitFieldType, LucideIcon> = {
  [PermitFieldType.StartFinishDates]: CalendarIcon,
  [PermitFieldType.AdditionalDate]: CalendarIcon,
  [PermitFieldType.Company]: Building2Icon,
  [PermitFieldType.CompanyInformational]: Building2Icon,
  [PermitFieldType.Requester]: UserStarIcon,
  [PermitFieldType.Assignee]: UserStarFilledIcon,
  [PermitFieldType.Subscriber]: UserBellIcon,
  [PermitFieldType.User]: UserIcon,
  [PermitFieldType.Location]: MapPinIcon,
  [PermitFieldType.LocationInformational]: MapPinIcon,
  [PermitFieldType.Equipment]: EquipmentIcon,
  [PermitFieldType.EquipmentInformational]: EquipmentIcon,
  [PermitFieldType.Material]: BoxIcon,
  [PermitFieldType.MaterialInformational]: BoxIcon,
  [PermitFieldType.MaterialResource]: PackageIcon,
  [PermitFieldType.MaterialResourceInformational]: PackageIcon,
  [PermitFieldType.File]: PaperclipIcon,
  [PermitFieldType.InputText]: TextShortIcon,
  [PermitFieldType.InputTextArea]: TextAlignStartIcon,
  [PermitFieldType.InputNumber]: HashIcon,
  [PermitFieldType.Time]: ClockIcon,
  [PermitFieldType.Select]: CircleChevronDownIcon,
  [PermitFieldType.Measure]: RulerIcon,
  [PermitFieldType.Email]: MailIcon,
  [PermitFieldType.PhoneNumber]: SmartphoneIcon,
  [PermitFieldType.Instructions]: ListIcon,
  [PermitFieldType.Checklist]: ListChecksIcon,
  [PermitFieldType.Question]: CircleQuestionMarkIcon,
  [PermitFieldType.Divider]: MinusIcon,
  [PermitFieldType.Section]: Heading1Icon,
  [PermitFieldType.Subsection]: Heading2Icon,
  [PermitFieldType.Text]: TypeIcon,
  [PermitFieldType.Table]: TableIcon,
  [PermitFieldType.RichText]: BaselineIcon,
  [PermitFieldType.LinkedWorkflow]: Workflow,
  [PermitFieldType.Activity]: ChartNoAxesGantt,
  [PermitFieldType.PrimaryActivity]: ChartNoAxesGantt,
  [PermitFieldType.Signature]: SignatureIcon,
  [PermitFieldType.InlineMedia]: Image,
}
